import { render, staticRenderFns } from "./PortsList.vue?vue&type=template&id=2a68afad"
import script from "./PortsList.vue?vue&type=script&lang=js"
export * from "./PortsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports